<!-- <app-common-header></app-common-header> -->
<main role="main" class="maincnt quest">
  <div
    class="getbannersect sectppad pb-2 pl-0 pr-0 chartScroll"
    id="scrollposition"
  >
    <div class="container">
      <div class="col-sm-12 p-0 mt-3" id="content">
        <!-- <h1
          class="headtxt headpadd mbpadt"
          style="
            font-family: 'Calibre';
            font-size: 18px;
            font-weight: 600;
            line-height: 18px;
          "
        >
          We compared
          <span style="color: #ed1976;" class="font-weight-semibold-calibre" >
            {{ providersCount }} electricity providers</span
          >
          and
          <a
            id="getAllPlans"
            href="javascript:void(0);"
            class="txtclr font-weight-semibold-calibre isEnabled"
            (click)="getAllPlanDetails()"
          >
            {{ prerecommendation.length }}
            plans</a
          >
          and ranked them according to your lifestyle, household and budget.
        </h1> -->
        <h1 
        style="
            font-family: 'Calibre';
            font-size: 18px;
            font-weight: 600;
            line-height: 18px;
          "
        class="headtxt headpadd mbpadt">
          Unbeatable savings! Lock in your plan now before rates change. These exclusive deals won’t last!
        </h1>
        <h1
          class="text-left searchtxt m-auto col-lg-9 p-0"
          style="
            color: #707070;
            font-family: 'Calibre';
            font-size: 16px;
            line-height: 14px;
           
          "
        >
          <!-- All pricing shown includes all fees, discounts and Oncor delivery
          charges. There are no hidden fees. -->
          <!-- All prices listed below include all electricity-related charges, fees, and discounts (and {{ getUtilityNameFromQuestionnaire() }} Delivery charges). We’ve calculated each plan based on their EFL and graphed it for easy comparison. 
          <br /> To see how much you could save with Honest Gorilla, locate your current electric bill and find where it says, <i>“The average price you paid for electric service this month (per kWh)”.</i> -->

          <!-- To find potential savings and see how much Honest Gorilla could help you save, check the section on your bill where it states, <strong><i>“The average price you paid for electric service this month (per kWh)” and compare.</i></strong> -->
          <!-- <br /> -->
          <br />
          <div style="background-color: grey !important; color: #fff; padding: 7px; border-radius: 6px;">
          ⚡No hidden fees — our rates cover all monthly electric provider and utility charges, except taxes.
         
          <i  data-html="true" data-toggle="tooltip" title="To find potential savings and see how much Honest Gorilla could help you save, check the section on your bill where it states, <strong><i>“The average price you paid for electric service this month (per kWh)” and compare.</i></strong>"         class="fa fa-question-circle ml-1"style="
          vertical-align: bottom !important;
          cursor: pointer !important;
          line-height:1.1
        "></i>

        </div>
        <br /> 
        </h1>
      </div>
      <div
        style="
          background: #e2e2e2;
          font-family: 'Calibre-SemiBold';
          font-size: 15px;
          margin-top: 10px;
          border-radius: 6px;
        "
      >
        <span style="padding-left: 10px;" (click)="showFilterCard()">Search Filters</span
        ><mat-icon style="position: absolute" (click)="showFilterCard()"
          >{{  showFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon
        >
        <span
          style="float: right; color: deeppink; margin-right: 5px"
          (click)="saveChanges()"
          *ngIf="showFilters"
          >Save Changes</span
        >
      </div>
      <mat-card class="example-card" *ngIf="showFilters">
        <mat-card-content>
          <div class="row">
            <div class="col">
              <h4 style="font-size: 16px">Product Types</h4>

              <div style="background: #e2e2e2; border-radius: 6px">
                <div
                  *ngFor="let productTypes of loadProductTypes; let i = index"
                  class="d-flex align-items-center"
                >
                  <!-- <input
                    type="checkbox"
                    id="{{ productTypes.value }}"
                    (click)="productchange($event, productTypes.value)"
                    #productTypesMob="ngModel"
                    [(ngModel)]="productTypes.checked"
                    name="example1"
                    value="{{ productTypes.value }}"
                    style="margin-right: 7px"
                  />
                  <label
                    for="prepaidmb11"
                    style="font-size: 11px; margin-bottom: 0"
                    >{{ productTypes.key }}</label
                  > -->

                  <div
                    class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                    style="margin-bottom: 0px !important"
                  >
                    <input
                      type="checkbox"
                      class="pdfclr custom-control-input"
                      style="margin-right: 7px"
                      id="ProductType_{{ productTypes.value }}"
                      (click)="productchange($event, productTypes.value)"
                      #productTypesMob="ngModel"
                      [(ngModel)]="productTypes.checked"
                      name="example1"
                      value="{{ productTypes.value }}"
                    />

                    <label
                      for="ProductType_{{ productTypes.value }}"
                      style="font-size: 16px; margin-bottom: 0px"
                      class="custom-control-label"
                      >{{ productTypes.key }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <h4 style="font-size: 16px">Select Avg Usage</h4>
              <div style="background: #e2e2e2; border-radius: 6px">
                <div
                  *ngFor="let avgUsage of loadAvgUsages; let i = index"
                  class="d-flex align-items-center"
                >
                  <!-- <input
                    type="checkbox"
                    id="{{ avgUsage.value }}"
                    (click)="selectAvgChange($event, avgUsage.value)"
                    #avgUsageMob="ngModel"
                    [(ngModel)]="avgUsage.checked"
                    name="example1"
                    value="{{ avgUsage.value }}"
                    style="margin-right: 7px"
                  />
                  <label style="font-size: 11px; margin-bottom: 0">{{
                    avgUsage.key
                  }}</label> -->

                  <div
                    class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                    style="margin-bottom: 0px !important"
                  >
                    <input
                      type="checkbox"
                      class="pdfclr custom-control-input"
                      style="margin-right: 7px"
                      id="Avg__{{ avgUsage.value }}"
                      (click)="selectAvgChange($event, avgUsage.value)"
                      #avgUsageMob="ngModel"
                      [(ngModel)]="avgUsage.checked"
                      name="example1"
                      value="{{ avgUsage.value }}"
                    />

                    <label
                      for="Avg__{{ avgUsage.value }}"
                      style="font-size: 16px; margin-bottom: 0px"
                      class="custom-control-label"
                      >{{ avgUsage.key }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="editgraph">
            <div
              *ngIf="showOption === true"
              class="row py-2 my-2"
              style="border-top: 1px solid #ccc; border-bottom: 2px solid #ccc"
            >
              <ng-container
                *ngFor="let monthObj of monthlyUsageArr; let j = index"
              >
                <div class="col-4 monthvice">
                  <label
                    *ngIf="monthObj.month === 'January'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Januarytrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Januarytrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Jan</label
                  >
                  <label
                    *ngIf="monthObj.month === 'February'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Februarytrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Februarytrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Feb</label
                  >
                  <label
                    *ngIf="monthObj.month === 'March'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Marchtrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Marchtrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Mar</label
                  >
                  <label
                    *ngIf="monthObj.month === 'April'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Apriltrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Apriltrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Apr</label
                  >
                  <label
                    *ngIf="monthObj.month === 'May'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Maytrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Maytrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >May</label
                  >
                  <label
                    *ngIf="monthObj.month === 'June'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Junetrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Junetrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Jun</label
                  >
                  <label
                    *ngIf="monthObj.month === 'July'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Julytrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Julytrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Jul</label
                  >
                  <label
                    *ngIf="monthObj.month === 'August'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Augusttrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Augusttrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Aug</label
                  >
                  <label
                    *ngIf="monthObj.month === 'September'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Septembertrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Septembertrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Sep</label
                  >
                  <label
                    *ngIf="monthObj.month === 'October'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Octobertrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Octobertrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Oct</label
                  >
                  <label
                    *ngIf="monthObj.month === 'November'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Novembertrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Novembertrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Nov</label
                  >
                  <label
                    *ngIf="monthObj.month === 'December'"
                    class="monthlabel"
                    [class.active]="monthactive === 'Decembertrue'"
                    [ngStyle]="{
                      'font-family':
                        monthactive === 'Decembertrue'
                          ? 'Calibre-SemiBold'
                          : 'Calibre'
                    }"
                    >Dec</label
                  >
                  <input
                    type="number"
                    (click)="monthvalueclick(monthObj)"
                    class="valueinput"
                    (keyup)="onKey($event, j)"
                    pattern="\d*"
                    value="{{ monthObj.usage }}"
                  />
                  <font>kWh</font>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h4 style="font-size: 16px; margin-top: 5px">Terms</h4>
              <div style="background: #e2e2e2; border-radius: 6px">
                <div class="row no-gutters">
                  <div
                    class="col-4"
                    *ngFor="let term of dropDownValues; let i = index"
                  >
                    <div class="d-flex align-items-center">
                      <!-- <input
                        type="checkbox"
                        class="pdfclr"
                        style="margin-right: 7px"
                        id="contractTerm{{ i + 1 }}"
                        name="example{{ i + 1 }}"
                        #terms="ngModel"
                        value="{{ term.value }}"
                        [(ngModel)]="term.checked"
                        (click)="selectthis($event, i + 1)"
                      />
                      <label
                        for="contractTerm{{ i + 1 }}"
                        *ngIf="term.value !== '1000'"
                        style="font-size: 11px; margin-bottom: 0"
                      >
                        {{ term.value }}
                      </label>
                      <label
                        for="contractTerm{{ i + 1 }}"
                        *ngIf="term.value === '1000'"
                        style="font-size: 11px; margin-bottom: 0"
                      >
                        Show All
                      </label> -->

                      <div
                        class="
                          custom-control custom-checkbox
                          chkbox
                          ml-2
                          my-0
                          mb-0
                        "
                        style="margin-bottom: 0px !important"
                      >
                        <input
                          type="checkbox"
                          class="pdfclr custom-control-input"
                          style="margin-right: 7px"
                          id="contractTerm{{ i + 1 }}"
                          name="example{{ i + 1 }}"
                          #terms="ngModel"
                          value="{{ term.value }}"
                          [(ngModel)]="term.checked"
                          (click)="selectthis($event, i + 1, 'Webview')"
                        />

                        <label
                          for="contractTerm{{ i + 1 }}"
                          *ngIf="term.value !== '1000'"
                          style="font-size: 16px; margin-bottom: 0"
                          class="custom-control-label"
                        >
                          {{ term.value }}
                        </label>
                        <label
                          for="contractTerm{{ i + 1 }}"
                          *ngIf="term.value === '1000'"
                          style="font-size: 16px; margin-bottom: 0"
                          class="custom-control-label"
                        >
                          Show All
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <h4 style="font-size: 16px">Energy Providers</h4>
              <div style="background: #e2e2e2; border-radius: 6px">
                <div class="row no-gutters">
                  <div
                    class="col-6"
                    *ngFor="
                      let energyObjMob of energyProviderList;
                      let i = index
                    "
                  >
                    <div class="d-flex px-2 align-items-center">
                      <!-- <div> -->
                      <div
                        class="custom-control custom-checkbox chkbox"
                        style="margin-bottom: 0px !important"
                      >
                        <input
                          type="checkbox"
                          class="pdfclr custom-control-input"
                          style="margin-right: 7px"
                          id="energyObj_{{ i + 1 }}"
                          name="example1"
                          #energyProviderMob="ngModel"
                          value="{{ energyObjMob.value }}"
                          [(ngModel)]="energyObjMob.checked"
                          (click)="selectthisEnergyProvider(i + 1)"
                        />

                        <label
                          for="energyObj_{{ i + 1 }}"
                          style="font-size: 16px; margin-bottom: 0px"
                          class="custom-control-label"
                        >
                          {{ energyObjMob.value }}</label
                        >
                      </div>
                      <!-- </div> -->

                      <!-- <input
                        type="checkbox"
                        style="margin-right: 7px"
                        id="energyObjMob{{ i + 1 }}"
                        name="example1"
                        #energyProviderMob="ngModel"
                        value="{{ energyObjMob.value }}"
                        [(ngModel)]="energyObjMob.checked"
                        (click)="selectMobEnergyProvider(i + 1, $event)"
                      />
                      <label
                        for="{{ energyObjMob.value }}"
                        style="font-size: 11px; margin-bottom: 0px"
                        >{{ energyObjMob.value }}</label
                      > -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div (click)="showFilterCard()">
            <mat-icon
              style="
                position: absolute;
                padding-left: 150px;
                padding-top: 10px;
                color: deeppink;
              "
              >keyboard_arrow_up</mat-icon
            >
          </div>
        </mat-card-content>
        <mat-card-actions> </mat-card-actions>
      </mat-card>
      <div
        class="col-sm-12 p-0 mt-3"
        id="content"
        *ngIf="noproduct || noproductdata"
      >
        <h1
          class="text-left searchtxt m-auto col-lg-9 p-0"
          style="
            color: #707070;
            font-family: 'Calibre';
            font-size: 15px;
            line-height: 14px;
          "
        >
          <h5>Use different criteria or compare these plans Instead</h5>
          <p style="font-size: 16px !important; line-height: 12px !important">
            No results found for this search.
          </p>
        </h1>
      </div>
      <div
        style="padding-top: 10px"
        class="row d-flex mt-2 mbpadt"
        id="chartbottom"
      >
        <div
          *ngIf="recommendationObj && recommendations"
          class="col-12 text-center horizandalchart" style="display: none;"
        >
          <span
            *ngFor="
              let productObj of preSelectedRecords | slice: 0:5;
              let i = index
            "
            class="d-flex mb-3 handsymbol"
           
            [class.active]="
              recommendations[productIndex].ProductID === productObj.ProductID
            "
            id="{{ productObj.ProductID }}"
          >
            <div class="col-1 form-control term-box">
              {{ productObj.terms }}
            </div>
            <div
              id="ep{{ productObj.ProductID }}"
              class="ml-2 form-control text-left"
              (click)="changeIUsageGraphbyProduct(productObj)"
              [style.width]="calculateWidth(productObj)"
            >
              {{ setEnergyProviderChartText(productObj) }}

              <font class="float-right text-nowrap"
                >{{ (productObj.new_tier.ave_price_per_KWH * 100).toFixed(1)
                }}<span style="color: #495057">&#162;</span>
              </font>
            </div>
            <div
              id="sign{{ productObj.ProductID }}"
              class="ml-2 form-control text-left var-container"
              style="width: 110px"
              (click)="orderProduct(productObj)"
            >
              <div class="w-100">
                <i
                  class="fa fa-check-square-o d-block pdfclr"
                  (click)="orderProduct(productObj)"
                  style="position: absolute; padding-right: 1"
                ></i
                ><span
                  style="
                    display: block;
                    position: relative;
                    margin-left: 16px;
                    font-size: 13px !important;
                  "
                  >Buy Now</span
                >
              </div>
            </div>
          </span>
        </div>
     
        <div style="display: none;" class="col-12">
          <div style="background: #e2e2e2; margin-bottom: 10px">
            <div class="row align-items-center" style="line-height: 12px">
              <div
                class="col text-right"
                style="font-size: 10px; line-height: 6px"
              >
                {{ setPaginationDetails(prerecommendation.length) }}
              </div>
              <div class="col-auto" style="padding-left: 0px !important">
                <mat-icon
                  matTooltip="Previous Records"
                  (click)="previousRecordSet()"
                  >keyboard_arrow_left</mat-icon
                >
              </div>
              <div class="col-auto">
                <mat-icon (click)="nextRecordSet()"
                  >keyboard_arrow_right</mat-icon
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mbpadt" style="float: left">
        <table
          class="w-100 mb-2 tbllayout handsymbol"
          *ngIf="recommendationObj && allRecommendations.length < 1"
        >
        <tr
       
        >
          <div *ngIf="recommendProduct != null && recommendProduct != undefined && recommendProduct.length != 0"
            id="prductListObj{{ recommendProduct.ProductID }}"
            class="plansummary othershadw mb-3 disableborder"
            (click)="changeIUsageGraph(recommendProduct, i + 1)"
          >
            <div class="d-flex pr-0 mbswipe">
              <div
                class="col-sm-9 col-md-8 col-lg-7 p-0 bdrrgtgry gesture__zone"
                (click)="onSwipe($event, recommendProduct.terms, i + 1)"
              >
                <div
                  class="
                    row
                    no-gutters
                    align-items-center align-items-stretch
                  "
                >
                  <div class="col-10">
                    <div class="row no-gutters align-items-center">
                      <div class="col-5">
                        <div class="bdrrgtgry">
                          <div
                            class="wrdbrk text-left"
                            style="
                              font-size: 14px;
                              font-family: 'Calibre-SemiBold';
                              line-height: 16px;
                            "
                          >
                            <img
                              src="{{
                                getImagesPerEnergyProviders(
                                  recommendProduct.energy_provider
                                )
                              }}"
                              style="margin: 10px 7px;"
                            />
                          </div>
                          <div
                            class="
                              font-weight-normal-calibre
                              wrdbrk
                              text-left
                            "
                            style="line-height: 12px;font-size:16px;margin-left: 10px;
                              margin-bottom: 5px;"
                          >
                            PUCT #{{ recommendProduct.puct }}
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <!-- <div class="">
                          <h1
                            class="
                              fwgtsix
                              rate
                              mt-0
                              mob-pt-5
                              avgvalue
                              mobavgpricelen32
                            "
                          >
                            {{ recommendProduct.price_units
                            }}{{
                              math.round(recommendProduct.new_tier.ave_monthly_bill)
                            }}
                          </h1>
                          <div style="line-height: 13px; font-size: 16px">
                            Avg Bill Estimate*
                          </div>
                        </div>
                      </div>
                      <div class="col"> -->
                        <div class="" style="text-align: left;">
                          <h1
                            class="
                              clrpink
                              fwgtsix
                              pikclr
                              avgvalue
                              mobavgpricelen32
                              ml-2
                            "
                          >
                            {{
                              (
                                recommendProduct.new_tier.ave_price_per_KWH * 100
                              ).toFixed(1)
                            }}¢
                          </h1>
                          
                        </div>
                       
                      </div>
                      <div class="col-4">
                        <div style="line-height: 15px; font-size: 16px">
                          Avg Price per <br/> {{ floor(recommendProduct.new_tier.ave_monthly_usage) }} kWh*
                        </div>
                      </div>
                    </div>
                    <hr class="m-0" />
                    <div class="row no-gutters align-items-center">
                      <div class="col-5">
                        <div class="bdrrgtgry p-2">
                          <div
                            class="wrdbrk text-left"
                            style="
                              
                              font-family: 'Calibre-SemiBold';
                              line-height: 16px;
                            "
                          >
                            {{ recommendProduct.product_key }}
                          </div>
                          <div
                            class="
                              font-weight-normal-calibre
                              wrdbrk
                              text-left
                            "
                            style="line-height: 12px"
                          >
                            {{ recommendProduct.terms }} Months -  {{ recommendProduct.ProductType }}
                            <!-- {{ recommendProduct.categoryName }} -->
                          </div>
                          <div
                            class="fwgtsix text-left"
                            *ngIf="recommendProduct.Renewable && recommendProduct.energy_provider !== 'Texpo Energy'" 
                          >
                            <a
                              class="float-left pikclr"
                              
                              target="_blank"
                              >{{ math.round(recommendProduct.Renewable) }}% Renewable</a
                            >
                          </div>
                          <div
                            style="
                              padding-top: 8px;
                              clear: both;
                              line-height: 4px;
                              text-decoration: underline;
                            "
                            class="text-left"
                            (click)="showSingleObjFilterCard(recommendProduct.ProductID,recommendProduct)"
                          >
                            {{  open == 'open'  && recommendProduct.ProductID === openIndex ? 'Hide Details' : 'Show Details' }} <mat-icon
                            style="position: absolute; font-size: 16px !important;line-height: inherit"
                            class="pointer"
                          
                            >{{  open == 'open'  && recommendProduct.ProductID === openIndex ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon
                          >
                          </div>
                        </div>
                      </div>
                      <div class="col-7" style="padding: 5px;">
                        <table width="100%" style="text-align: center; font-size: 16px; background: #F0F0F0; ">
                        <tbody>
                          <tr>
                            <th>500 kWh</th>
                            <th>1000 kWh</th>
                            <th>2000 kWh</th>
                          </tr>
                          <tr style="line-height: 0.5;">
                            <td style="padding: 0px !important;">{{(recommendProduct.tier[0].avg_charge * 100).toFixed(1)}}¢</td>
                            <td style="padding: 0px !important;">{{(recommendProduct.tier[1].avg_charge * 100).toFixed(1)}}¢</td>
                            <td style="padding: 0px !important;">{{(recommendProduct.tier[2].avg_charge * 100).toFixed(1)}}¢</td>
                          </tr>
                        </tbody>
                      </table>

                      <highcharts-chart
                      [Highcharts]="Highcharts"
                      [options]="{
                        chart: { type: 'line', backgroundColor: 'transparent'}, 
                        xAxis: {
                          visible: false
                        },
                        yAxis: {
                          visible: false
                        },
                        legend: {
                          enabled: false
                        },
                        credits: {
                          enabled: false
                        },
                        tooltip: {
                          pointFormat: '{point.y}¢',
                          headerFormat: '',
                          footerFormat: ''
                        },
                        title: { text: ''},
                        series: [{ data: [+(recommendProduct.tier[0].avg_charge * 100).toFixed(1),
                                          +(recommendProduct.tier[1].avg_charge * 100).toFixed(1),
                                          +(recommendProduct.tier[2].avg_charge * 100).toFixed(1)
                                        ],
                                color: 'black' }]
                        
                      }"
                      [runOutsideAngular]="true"
                      style="width: 100%; height: 70px; display: block;
                          padding-left: 10px;
                          background: #F0F0F0;
                          padding-right: 10px;
                          padding-top:10px
                      "
                    ></highcharts-chart>
                    
                      </div>
                      
                    </div>
                  </div>
                  <div class="col-2">
                    <div
                      style="background: #ed1976;display: flex;
                        align-items: center;color: white; "
                      class="orderNow h-100"
                      (click)="orderProduct(recommendProduct)"
                    >
                      <div
                        style=" margin: auto; "
                      >
                        <i
                          class="d-block font25 pdfclr"
                          (click)="orderProduct(recommendProduct)"
                        ></i
                        >Buy Now
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf=" open == 'open'  && recommendProduct.ProductID === openIndex"
            >
              <div class="plan mobileview row no-gutters px-2">
                <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                  <p
                    class="fwgtsix"
                    style="font-size: 16px; font-weight: bolder"
                  >
                    Description
                  </p>
                  <p
                    class="font-weight-normal-calibre text-left"
                    style="font-size: 16px"
                    [innerHTML]="recommendProduct.description"
                  ></p>
                </div>
                <div class="d-flex mt-1" style="text-decoration: underline;">
                  <div class="col-2 d-flex flex-row pl-0 text-left">
                    <div class="float-left">
                      <img src="assets/images/pdf.svg" width="18" />
                    </div>
                    <div>
                      <a
                        class="float-left pikclr pt-1 pl-1"
                        href="{{ recommendProduct.productEFL }}"
                        target="_blank"
                        style="color: black !important;text-decoration: underline;"
                        >EFL</a
                      >
                    </div>
                  </div>
  
                  <div class="col-2 d-flex flex-row flexauto text-left">
                    <div class="float-left">
                      <img src="assets/images/pdf.svg" width="18" />
                    </div>
                    <div>
                      <a
                        class="float-left pikclr pt-1 pl-1"
                        href="{{ recommendProduct.productTOS }}"
                        target="_blank"
                        style="color: black !important;text-decoration: underline;"
                        >TOS</a
                      >
                    </div>
                  </div>
                  <div class="col-4 d-flex flex-row flexauto pr-0 text-left">
                    <div class="float-left">
                      <img src="assets/images/pdf.svg" width="18" />
                    </div>
                    <div>
                      <a
                        class="float-left pikclr pt-1 pl-1"
                        href="{{ recommendProduct.productYRAC }}"
                        target="_blank"
                        style="color: black !important;text-decoration: underline;"
                        >YRAC</a
                      >
                    </div>
                  </div>
                </div>
  
                <div class="col-sm-8 col-md-8 col-lg-8 pt-3">
                  <p
                    class="fwgtsix text-left"
                    style="font-weight: bolder"
                  >
                    Pricing Details
                  </p>
                  <div class="rounded">
                    <div class="mb-2">
                      <table class="table" style="margin-bottom: 0px">
                        <thead>
                          <tr style="background: #e2e2e2">
                            <th
                              scope="col"
                              class="font16 bold2 text-center"
                              style="
                                padding: 0.05rem !important;
                                vertical-align: top;
                                border-top: 1px solid #dee2e6;
                                font-weight:bold
                              "
                            >
                              Monthly Usage
                            </th>
                            <th
                              scope="col"
                              class="font16 bold2 text-center"
                              style="
                                padding: 0.05rem !important;
                                vertical-align: top;
                                border-top: 1px solid #dee2e6;
                                font-weight:bold
                              "
                            >
                              Average Price Per kWh
                            </th>
                            <th
                              scope="col"
                              class="font16 bold2 text-center"
                              style="
                                padding: 0.05rem !important;
                                vertical-align: top;
                                border-top: 1px solid #dee2e6;
                                font-weight:bold
                              "
                            >
                              Monthly Estimate
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          style="
                            font-size: 16px;
                            font-family: Calibre;
                            text-align: center;
                            line-height: 10px;
                          "
                        >
                          <tr>
                            <td>500 kWh</td>
                            <td>{{ avgCharge500 }}¢</td>
                            <td>${{ monthlyEstimates[0] }}</td>
                          </tr>
                          <tr>
                            <td>1000 kWh</td>
                            <td>{{ avgCharge1000 }}¢</td>
                            <td>${{ monthlyEstimates[1] }}</td>
                          </tr>
                          <tr>
                            <td>2000 kWh</td>
                            <td>{{ avgCharge2000 }}¢</td>
                            <td>${{ monthlyEstimates[2] }}</td>
                          </tr>
                          <tr>
                            <td style="background: deeppink; color: white">
                              {{ averageMonthlyUsage }} kWh
                            </td>
                            <td style="color: deeppink">
                              {{ avgPricePerKWH }}¢
                            </td>
                            <td style="color: deeppink">
                              ${{ avgMonthlyBill }}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="
                                font-size: 16px !important;
                                padding: 0.05rem !important;
                                line-height: 1
                              "
                            >
                              Your Avg*
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div style="line-height: 1;">
                    <div style="font-size: 16px;line-height: 1.1; ">
                      <p class="mb-0" style="font-weight: bolder;font-family: 'Calibre-SemiBold'">
                        How Your Bill is Calculated for {{averageMonthlyUsage}} kWh Usage
                        
                      </p>
                      
                    </div>
                    <div
                      style="
                        font-size: 16px;
                        font-family: Calibre;
                        line-height: 1;
                      "
                    >
                      <p  class="mb-0" *ngIf="recommendProduct.energy_provider !== '4Change Energy' && recommendProduct.energy_provider !== 'Rhythm Energy' && recommendProduct.energy_provider !== 'APGE Energy' && recommendProduct.energy_provider !== 'Pulse Power'  && recommendProduct.energy_provider !== 'New Power Texas' && recommendProduct.energy_provider !== 'Shell Energy' ">
                        <span style="font-weight: bold">Energy Charge</span>:
                        {{ setValidatedValue(recommendedEnergyCharge) }}
                        per kWh
                      </p>
                      <p  class="mb-0"*ngIf="recommendProduct.energy_provider == '4Change Energy'">
                        <span style="font-weight: bold">Energy Charge</span>:
                        {{ setValidatedValue_4Change(recommendedEnergyCharge) }}
                        per kWh
                      </p>
                      <p  class="mb-0"*ngIf="(recommendProduct.energy_provider == 'Pulse Power' || recommendProduct.energy_provider == 'New Power Texas' || recommendProduct.energy_provider == 'Shell Energy')  && recommendProduct.ProductType != 'TimeOfUse'">
                        <span style="font-weight: bold">Energy Charge</span>:
                        {{ setValidatedValue_Pulse(recommendedEnergyCharge) }}
                        per kWh
                      </p>

                      <div *ngIf="(recommendProduct.energy_provider == 'Pulse Power' || recommendProduct.energy_provider == 'New Power Texas')   && recommendProduct.ProductType == 'TimeOfUse'">

                        <p  class="mb-0">
                          <span style="font-weight: bold">Daytime Energy Charge</span>: {{ setValidatedValue_Pulse(recommendedEnergyCharge) }}
                        </p>
                        <p class="mb-0">
                          <span style="font-weight: bold">Daytime Energy Factor</span>: 60% 
                        </p>
                        <p  class="mb-0">
                          <span style="font-weight: bold">Nighttime Energy Charge</span>: FREE
                        </p>
                        <p  class="mb-0">
                          <span style="font-weight: bold">Nighttime Energy Factor</span>: 40% 
                        </p>
                      </div>

                      
                      <p  class="mb-0"*ngIf="recommendProduct.energy_provider == 'Rhythm Energy' || recommendProduct.energy_provider == 'APGE Energy' ">
                        <span style="font-weight: bold">Energy Charge</span>:
                        {{ setValidatedValue_Rhythm(recommendedEnergyCharge) }}
                        per kWh
                      </p>
                      <p class="mb-0"  *ngIf="recommendedBaseFee !== 0 && recommendProduct.energy_provider === '4Change Energy'">
                        <span style="font-weight: bold">Base Charge</span>:
                        $0.00 
                        per billing cycle
                      </p>
                      <p
                      *ngIf=" recommendProduct.base_fee != null &&
                      recommendProduct.energy_provider === '4Change Energy'
                        
                      "
                      class="WordSpace mb-0"
                    >
                     <span style="font-weight: bold"> Base Charge</span>:
                      
                      ${{ recommendProduct.base_fee}} 
                      per billing cycle
                    </p>
                      <p class="mb-0" *ngIf="recommendedBaseFee !== 0 && recommendProduct.energy_provider !== '4Change Energy'">
                        <span style="font-weight: bold">Base Charge</span>:
                        ${{ recommendedBaseFee == "N/A" || recommendedBaseFee == "0" ? '0.00' :  recommendedBaseFee}}
                        per billing cycle for usage
                        kWh
                      </p>
                      <p
                      class="WordSpace mb-0"
                      *ngIf="recommendProduct.energy_provider === '4Change Energy'"
                       >
                       <span style="font-weight: bold"> Bill Credit</span>:
                     
                      {{ removeminus(recommendProduct.billCredit) }} per billing cycle of atleast {{ recommendProduct.usageTrigger }} kWh

                    </p>
                    <p
                    class="WordSpace mb-0"
                    *ngIf="recommendProduct.energy_provider === 'Texpo Energy'"
                  >
                  <span style="font-weight: bold"> Minimum Usage Fee</span>:
                    ${{ recommendProduct.minEnergyCharge }} (for usage less than {{ recommendProduct.minEnergyUsage }} kWh)

                  </p>

                      <p
                      class="WordSpace mb-0"
                      *ngIf="recommendProduct.energy_provider === 'Shell Energy' && recommendProduct.minEnergyCharge != 0 "
                    >
                      <span style="font-weight: bold"> Minimum Usage Fee</span>:
                      ${{ recommendProduct.minEnergyCharge }} (all usage below {{ recommendProduct.minEnergyUsage }} kWh)

                    </p>
                    <p
                    class="WordSpace mb-0"
                    *ngIf="recommendProduct.energy_provider === 'Shell Energy'  && recommendProduct.ProductType.indexOf('Buyback') > -1 "
                  >
                     <span style="font-weight: bold">Solar Buyback Rate: </span>Real-Time Market Rate

                  </p>

                    <p 
                    class="mb-0"
                            
                    *ngIf="
                      (
                      recommendProduct.energy_provider === 'New Power Texas') && recommendProduct.billCredit != undefined  && recommendProduct.minEnergyUsage !== 0 &&  recommendProduct.billCredit !== 0
                    "
                  >
                    <span style="font-weight: bold">Usage Credit</span>:

                    {{ removeminus(recommendProduct.billCredit) }} per billing cycle of atleast {{ recommendProduct.minEnergyUsage }} kWh
                  </p>
                  <p 
                  *ngIf="
                    (recommendProduct.usage1 != null ||
                    recommendProduct.usage2 != null) &&
                    (recommendProduct.energy_provider === 'Gexa Energy' ||
                    recommendProduct.energy_provider ===
                        'Frontier Utilities')
                  "
                   class="WordSpace mb-0"
                >
                <span style="font-weight: bold">Usage Credit</span>:  {{recommendProduct.usage1Charge}} per billing cycle for usage >={{recommendProduct.usage1}} kWh
                </p>
                      <p
                      class="WordSpace mb-0"
                      *ngIf="
                        (
                          recommendProduct.energy_provider === 'Chariot Energy') && recommendProduct.billCredit !== '0' &&  recommendProduct.billCreditTrigger !== '0'
                      "
                    >
                    <span style="font-weight: bold"> Usage Credit:</span>
                    {{ removeminus(recommendProduct.billCredit) }} per billing cycle of atleast {{ recommendProduct.billCreditTrigger }} kWh
                    </p>
                        

                    <div
                    *ngIf="
                    recommendProduct.energy_provider != 'Pulse Power' &&  recommendProduct.energy_provider != 'New Power Texas' 
                    
                    "
                    >

                      
                      <p class="mb-0">
                        <span style="font-weight: bold"
                          >TDU Delivery Charge</span
                        >: ${{ recommendedTduCharge }} per billing cycle
                      </p>
                      <p class="mb-0">
                        <span style="font-weight: bold"
                          >TDU Delivery Charge</span
                        >: ${{ recommendedTduDeliveryCharge }}
                        per kWh
                      </p>
                     </div>

                     <div
                    *ngIf="
                    (recommendProduct.energy_provider == 'Pulse Power' || recommendProduct.energy_provider == 'New Power Texas')  && recommendProduct.ProductType == 'TimeOfUse'
                    
                    "
                    >

                      
                      <p class="mb-0">
                        <span style="font-weight: bold"
                          >TDU Delivery Charge</span
                        >: ${{ recommendedTduCharge }} per billing cycle
                      </p>
                      <p class="mb-0">
                        <span style="font-weight: bold"
                          >TDU Delivery Charge</span
                        >: ${{ recommendedTduDeliveryCharge }}
                        per kWh
                      </p>
                     </div>

                     <div
                     *ngIf="
                     (recommendProduct.energy_provider == 'Pulse Power' || recommendProduct.energy_provider == 'New Power Texas')  && recommendProduct.ProductType != 'TimeOfUse'
                     "
                     >
 
                       <!-- <p>
                         <span style="font-weight: bold"
                           >TDU Delivery Charge</span
                         >: Bundled / Included per billing cycle
                       </p>
                       <p>
                         <span style="font-weight: bold"
                           >TDU Delivery Charge</span
                         >: Bundled / Included
                         per kWh
                       </p>
                        -->
                        <p class="mb-0">
                          <span style="font-weight: bold"
                            >TDU Delivery Charge</span
                          >: ${{ recommendedTduCharge }} per billing cycle
                        </p>
                        <p class="mb-0">
                          <span style="font-weight: bold"
                            >TDU Delivery Charge</span
                          >: ${{ recommendedTduDeliveryCharge }}
                          per kWh
                        </p>

                      </div>
                      <p class="mb-0"
                      *ngIf="
                      (recommendProduct.energy_provider === 'Chariot Energy' ||
                      recommendProduct.energy_provider === 'APGE Energy')
                      "
                      >
                        <span style="font-weight: bold"
                          > {{ recommendProduct.energy_provider === 'Chariot Energy' ? "Ercot Securitization Charge" : "Securitization Charge" }}</span
                        >: ${{recommendProduct.SecuritizationCharge}} per kWh
                      </p>

                    </div>
                    <div
                    *ngIf="
                       recommendProduct.energy_provider != 'Pulse Power' &&  recommendProduct.energy_provider != 'New Power Texas'
                    "
                      style="
                        font-size: 16px;
                        font-family: Calibre;
                       
                      "
                    >
                      *Avg. Price per kWh = ({{ productTitle }} Energy Charges {{ recommendProduct.energy_provider === 'APGE Energy' ? "+ Base Charge " :"" }}+ TDU
                      Charges {{recommendProduct.energy_provider === 'Chariot Energy' || recommendProduct.energy_provider === 'APGE Energy' ? recommendProduct.SecuritizationChargeLabel : ""}} ) / Total Monthly Usage
                    </div>
                    <div
                    *ngIf="
                    (recommendProduct.energy_provider === 'Pulse Power' || recommendProduct.energy_provider === 'New Power Texas')  && recommendProduct.ProductType != 'TimeOfUse'
                    "
                    style="
                      font-size: 16px;
                      font-family: Calibre;
                     
                    "
                  >
                  *Avg Price per kWh = (Energy Charge x Total Monthly Usage) + Base Charge
                  </div>
                  <div
                  *ngIf="
                  (recommendProduct.energy_provider === 'Pulse Power' || recommendProduct.energy_provider === 'New Power Texas')  && recommendProduct.ProductType == 'TimeOfUse'
                  "
                  style="
                    font-size: 16px;
                    font-family: Calibre;
                  
                  "
                >
                *Price per kWh = [TDU Delivery Charges per Month + (Monthly billed kWh Usage x (Energy Rate + TDU Delivery Charges per kWh)) - (Energy Rate x applicable Free Charging kWh Usage)]/Monthly Billed kWh Usage.
                </div>
                  </div>
                </div>
              </div>
            </div>
              <div
                class="plan mobileview row no-gutters px-2"
                style="border-top: 0px; margin-top: 8px"
              >
                <div
                  class="fwgtsix pt-2"
                  style="
                    font-size: 16px;
                    font-weight: bolder;
                    text-decoration: underline;
                  "
                  (click)="showHighcharts()"
                >
                  {{ toggleHighcharts ? 'Hide Estimated Bill & Usage Chart' : 'See Estimated Bill & Usage Chart' }}
                  <mat-icon
                    style="position: absolute;line-height: inherit;"
                    class="pointer"
                  
                    >{{ toggleHighcharts ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                </div>
              </div>
              <div
                class="col-12 p-0 float-left mobileTrigger"
                style="margin-top: 20px"
                *ngIf="toggleHighcharts"
              >
                <highcharts-chart
                  [Highcharts]="Highcharts"
                  [options]="highChartsOptions"
                  [(update)]="updateValue"
                  [runOutsideAngular]="true"
                  style="width: 100%; height: 350px; display: block"
                ></highcharts-chart>
              </div>
              <div class="text-center m-auto pb-2 p-3">
                <a
                  class="btn signup font12 sectbtnhvr mt-0 mbsign"
                  style="width: 110px"
                  (click)="orderProduct(recommendProduct)"
                  >Buy Now</a
                ><br />
                <i
                  class="fa fa-angle-up font33 pdfclr mt-3"
                  aria-hidden="true"
                  (click)="showDetail1()"
                ></i>
              </div>
            </div>
          </div>
        </tr>

   

        

          <tr
            *ngFor="
              let singleObj of recommendations
                | slice: 1:recommendations.length;
              let i = index
            "
            id="i+1"
          >
            <div
              id="prductListObj{{ singleObj.ProductID }}"
              class="plansummary othershadw mb-3 disableborder"
              (click)="changeIUsageGraph(singleObj, i + 1)"
            >
              <div class="d-flex pr-0 mbswipe">
                <div
                  class="col-sm-9 col-md-8 col-lg-7 p-0 bdrrgtgry gesture__zone"
                  (click)="onSwipe($event, singleObj.terms, i + 1)"
                >
                  <div
                    class="
                      row
                      no-gutters
                      align-items-center align-items-stretch
                    "
                  >
                    <div class="col-10">
                      <div class="row no-gutters align-items-center">
                        <div class="col-5">
                          <div class="bdrrgtgry">
                            <div
                              class="wrdbrk text-left"
                              style="
                                font-size: 14px;
                                font-family: 'Calibre-SemiBold';
                                line-height: 16px;
                              "
                            >
                              <img
                                src="{{
                                  getImagesPerEnergyProviders(
                                    singleObj.energy_provider
                                  )
                                }}"
                                style="margin: 10px 7px;"
                              />
                            </div>
                            <div
                              class="
                                font-weight-normal-calibre
                                wrdbrk
                                text-left
                              "
                              style="line-height: 12px;font-size:16px;margin-left: 10px;
                              margin-bottom: 5px;"
                            >
                              PUCT #{{ singleObj.puct }}
                            </div>
                          </div>
                        </div>
                        <div class="col-3">
                            <!-- <div class="">
                                <h1 class="
                                fwgtsix
                                rate
                                mt-0
                                mob-pt-5
                                avgvalue
                                mobavgpricelen32
                              ">
                                    {{
 singleObj.price_units
                                    }}{{
                                math.round(singleObj.new_tier.ave_monthly_bill)
                                    }}
                                </h1>
                                <div style="line-height: 13px; font-size: 16px">
                                    Avg Bill Estimate*
                                </div>
                            </div>
                        </div>
                        <div class="col"> -->
                          <div class="" style="text-align: left;">
                            <h1
                              class="
                                clrpink
                                fwgtsix
                                pikclr
                                avgvalue
                                mobavgpricelen32
                                ml-2
                              "
                            >
                              {{
                                (
                                  singleObj.new_tier.ave_price_per_KWH * 100
                                ).toFixed(1)
                              }}¢
                            </h1>
                           
                          </div>
                         
                        </div>
                        <div class="col-4">
                          <div style="line-height: 15px; font-size: 16px ">
                          Avg Price per <br/> {{ floor(singleObj.new_tier.ave_monthly_usage) }} kWh*
                        </div>
                        </div>
                      </div>
                      <hr class="m-0" />
                      <div class="row no-gutters align-items-center">
                        <div class="col-5">
                          <div class="bdrrgtgry p-2">
                            <div
                              class="wrdbrk text-left"
                              style="
                                
                                font-family: 'Calibre-SemiBold';
                                line-height: 16px;
                              "
                            >
                              {{ singleObj.product_key }}
                            </div>
                            <div
                              class="
                                font-weight-normal-calibre
                                wrdbrk
                                text-left
                              "
                              style="line-height: 12px"
                            >
                              {{ singleObj.terms }} Months - {{ singleObj.ProductType }}
                              <!-- {{ singleObj.categoryName }} -->
                            </div>
                            <div
                              class="fwgtsix text-left"
                              *ngIf="singleObj.Renewable && singleObj.energy_provider !== 'Texpo Energy'" 
                            >
                              <a
                                class="float-left pikclr"
                                target="_blank"
                                >{{ math.round(singleObj.Renewable) }}% Renewable</a
                              >
                            </div>
                            <div
                              style="
                                padding-top: 8px;
                                clear: both;
                                line-height: 4px;
                                text-decoration: underline;
                              "
                              class="text-left"
                              (click)="openDialog(singleObj)"
                            >
                              {{ 
                                open == 'open'  && singleObj.ProductID === openIndex
                                ? 'Hide Details' : 'Show Details' }}  <mat-icon
                              style="position: absolute; font-size: 16px !important;line-height: inherit;"
                              class="pointer"
                            
                              >{{ 
                                open == 'open'  && singleObj.ProductID === openIndex
                                ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon
                            >
                            </div>
                          </div>
                        </div>
                        <div class="col-7" style="padding: 5px;">
                      

                            <table width="100%" style="text-align:center;font-size: 16px;

                            background: #F0F0F0;
                          ">
                                <tbody>
                                    <tr>
                                        <th>500 kWh</th>
                                        <th>1000 kWh</th>
                                        <th>2000 kWh</th>
                                    </tr>
                                    <tr style="line-height: 0.5;">
                                        <td style="padding: 0px !important;">{{(singleObj.tier[0].avg_charge * 100).toFixed(1)}}¢</td>
                                        <td style="padding: 0px !important;">{{(singleObj.tier[1].avg_charge * 100).toFixed(1)}}¢</td>
                                        <td style="padding: 0px !important;">{{(singleObj.tier[2].avg_charge * 100).toFixed(1)}}¢</td>
                                    </tr>
                                </tbody>
                            </table>

                            <highcharts-chart [Highcharts]="Highcharts"
                                              [options]="{
                            chart: { type: 'line', backgroundColor: 'transparent'},
                            xAxis: {
                              visible: false
                            },
                            yAxis: {
                              visible: false
                            },
                            legend: {
                              enabled: false
                            },
                            credits: {
                              enabled: false
                            },
                            tooltip: {
                              pointFormat: '{point.y}¢',
                              headerFormat: '',
                              footerFormat: ''
                            },
                            title: { text: ''},
                            series: [{ data: [+(singleObj.tier[0].avg_charge * 100).toFixed(1),
                                              +(singleObj.tier[1].avg_charge * 100).toFixed(1),
                                              +(singleObj.tier[2].avg_charge * 100).toFixed(1)
                                            ],
                                    color: 'black' }]

                          }"
                                              [runOutsideAngular]="true"
                                              style="width: 100%; height: 70px; display: block;
                              padding-left: 10px;
                              background: #F0F0F0;
                              padding-right: 10px;
                              padding-top:10px
                          "></highcharts-chart>
                        </div>
                      </div>
                    </div>
                    <div class="col-2">
                      <div
                        style="background: #ed1976;display: flex;
                        align-items: center;color: white;"
                        class="orderNow h-100"
                        (click)="orderProduct(singleObj)"
                      >
                        <div
                          style="
                            
                            margin: auto;
                          "
                        >
                          <i
                            class="d-block font25 pdfclr"
                            (click)="orderProduct(singleObj)"
                          ></i
                          >Buy Now
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="
                  open == 'open'  && singleObj.ProductID === openIndex
                "
              >
                <div class="plan mobileview row no-gutters px-2">
                  <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                    <p
                      class="fwgtsix"
                      style="font-size: 16px; font-weight: bolder"
                    >
                      Description
                    </p>
                    <p
                      class="font-weight-normal-calibre text-left"
                      style="font-size: 16px"
                      [innerHTML]="singleObj.description"
                    ></p>
                  </div>
                  <div class="d-flex mt-1">
                    <div class="col-2 d-flex flex-row pl-0 text-left">
                      <div class="float-left">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="float-left pikclr pt-1 pl-1"
                          href="{{ singleObj.productEFL }}"
                          target="_blank"
                          style="color: black !important;text-decoration: underline;"
                          >EFL</a
                        >
                      </div>
                    </div>

                    <div class="col-2 d-flex flex-row flexauto text-left">
                      <div class="float-left">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="float-left pikclr pt-1 pl-1"
                          href="{{ singleObj.productTOS }}"
                          target="_blank"
                          style="color: black !important;text-decoration: underline;"
                          >TOS</a
                        >
                      </div>
                    </div>
                    <div class="col-4 d-flex flex-row flexauto pr-0 text-left">
                      <div class="float-left">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="float-left pikclr pt-1 pl-1"
                          href="{{ singleObj.productYRAC }}"
                          target="_blank"
                          style="color: black !important;text-decoration: underline;"
                          >YRAC</a
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-8 col-md-8 col-lg-8 pt-3">
                    <p
                      class="fwgtsix text-left"
                      style="font-weight: bolder"
                    >
                      Pricing Details
                    </p>
                    <div class="rounded">
                      <div class="mb-2">
                        <table class="table" style="margin-bottom: 0px">
                          <thead>
                            <tr style="background: #e2e2e2">
                              <th
                                scope="col"
                                class="font16 bold2 text-center"
                                style="
                                  padding: 0.05rem !important;
                                  vertical-align: top;
                                  border-top: 1px solid #dee2e6;
                                  font-weight:bold
                                "
                              >
                                Monthly Usage
                              </th>
                              <th
                                scope="col"
                                class="font16 bold2 text-center"
                                style="
                                  padding: 0.05rem !important;
                                  vertical-align: top;
                                  border-top: 1px solid #dee2e6;
                                  font-weight:bold
                                "
                              >
                                Average Price Per kWh
                              </th>
                              <th
                                scope="col"
                                class="font16 bold2 text-center"
                                style="
                                  padding: 0.05rem !important;
                                  vertical-align: top;
                                  border-top: 1px solid #dee2e6;
                                  font-weight:bold
                                "
                              >
                                Monthly Estimate
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            style="
                              font-size: 16px;
                              font-family: Calibre;
                              text-align: center;
                              line-height: 10px;
                            "
                          >
                            <tr>
                              <td>500 kWh</td>
                              <td>{{ avgCharge500 }}¢</td>
                              <td>${{ monthlyEstimates[0] }}</td>
                            </tr>
                            <tr>
                              <td>1000 kWh</td>
                              <td>{{ avgCharge1000 }}¢</td>
                              <td>${{ monthlyEstimates[1] }}</td>
                            </tr>
                            <tr>
                              <td>2000 kWh</td>
                              <td>{{ avgCharge2000 }}¢</td>
                              <td>${{ monthlyEstimates[2] }}</td>
                            </tr>
                            <tr>
                              <td style="background: deeppink; color: white">
                                {{ averageMonthlyUsage }} kWh
                              </td>
                              <td style="color: deeppink">
                                {{ avgPricePerKWH }}¢
                              </td>
                              <td style="color: deeppink">
                                ${{ avgMonthlyBill }}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style="
                                  font-size: 16px !important;
                                  padding: 0.05rem !important;
                                  line-height: 1;
                                "
                              >
                                Your Avg*
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div style="line-height: 1;">
                        <div style="font-size: 16px;">
                          <p class="mb-0" style="font-weight: bolder;font-family: 'Calibre-SemiBold'">
                            How Your Bill is Calculated for {{ averageMonthlyUsage }} kWh Usage
                          </p>
                          
                        </div>
                        <div
                          style="
                            font-size: 16px;
                            font-family: Calibre;
                            line-height: 1;
                          "
                        >
                          <p  class="mb-0" *ngIf="singleObj.energy_provider !== '4Change Energy' && singleObj.energy_provider !== 'Rhythm Energy' && singleObj.energy_provider !== 'APGE Energy'  && singleObj.energy_provider !== 'Pulse Power' && singleObj.energy_provider !== 'New Power Texas'  && singleObj.energy_provider !== 'Shell Energy'">
                            <span style="font-weight: bold">Energy Charge</span>:
                            {{ setValidatedValue(recommendedEnergyCharge) }}
                            per kWh
                          </p>
                          <p class="mb-0" *ngIf="singleObj.energy_provider == '4Change Energy'">
                            <span style="font-weight: bold">Energy Charge</span>:
                            {{ setValidatedValue_4Change(recommendedEnergyCharge) }}
                            per kWh
                          </p>
                          <p class="mb-0" *ngIf="(singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas'  || singleObj.energy_provider == 'Shell Energy')  && singleObj.ProductType != 'TimeOfUse'">
                            <span style="font-weight: bold">Energy Charge</span>:
                            {{ setValidatedValue_Pulse(recommendedEnergyCharge) }}
                            per kWh
                          </p>
                          
                          <div *ngIf=" (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' )  && singleObj.ProductType == 'TimeOfUse'">

                            <p class="mb-0">
                              <span style="font-weight: bold">Daytime Energy Charge</span>: {{ setValidatedValue_Pulse(recommendedEnergyCharge) }}
                            </p>
                            <p class="mb-0">
                              <span style="font-weight: bold">Daytime Energy Factor</span>: 60% 
                            </p>
                            <p class="mb-0">
                              <span style="font-weight: bold">Nighttime Energy Charge</span>: FREE
                            </p>
                            <p class="mb-0">
                              <span style="font-weight: bold">Nighttime Energy Factor</span>: 40% 
                            </p>
                          </div>
                          <p class="mb-0" *ngIf="singleObj.energy_provider == 'Rhythm Energy'  || singleObj.energy_provider == 'APGE Energy'">
                            <span style="font-weight: bold">Energy Charge</span>:
                            {{ setValidatedValue_Rhythm(recommendedEnergyCharge) }}
                            per kWh
                          </p>                  
                        
                          <p
                          *ngIf=" singleObj.base_fee != null &&
                          singleObj.energy_provider === '4Change Energy'
                            
                          "
                          class="WordSpace mb-0"
                        >
                        <span style="font-weight: bold"> Base Charge</span>:
                          ${{ singleObj.base_fee}} 
                          per billing cycle
                        </p>
                          <p class="mb-0" *ngIf="recommendedBaseFee !== 0 && singleObj.energy_provider !== '4Change Energy'">
                            <span style="font-weight: bold">Base Charge</span>:
                            ${{ recommendedBaseFee == "N/A" || recommendedBaseFee == "0" ? '0.00' :  recommendedBaseFee}}
                            per billing cycle for usage
                            kWh
                          </p>
                          <p
                          class="WordSpace mb-0"
                          *ngIf="singleObj.energy_provider === '4Change Energy'"
                          >
                          <span style="font-weight: bold"> Bill Credit</span>:
                        
                          {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.usageTrigger }} kWh

                        </p>
                        <p
                          class="WordSpace mb-0"
                          *ngIf="singleObj.energy_provider === 'Texpo Energy'"
                        >
                        <span style="font-weight: bold"> Minimum Usage Fee</span>:
                          
                          ${{ singleObj.minEnergyCharge }} (for usage less than {{ singleObj.minEnergyUsage }} kWh)
      
                        </p>

                      <p
                          class="WordSpace mb-0"
                          *ngIf="singleObj.energy_provider === 'Shell Energy'  && singleObj.minEnergyCharge != 0 "
                        >
                          <span style="font-weight: bold"> Minimum Usage Fee</span>:
                          ${{ singleObj.minEnergyCharge }} (all usage below {{ singleObj.minEnergyUsage }} kWh)

                        </p>
                        <p
                          class="WordSpace mb-0"
                          *ngIf="singleObj.energy_provider === 'Shell Energy'  && singleObj.ProductType.indexOf('Buyback') > -1 "
                        >
                          <span style="font-weight: bold">Solar Buyback Rate: </span>Real-Time Market Rate

                        </p>
                        

                        <p
                        *ngIf="
                          (singleObj.usage1 != null ||
                          singleObj.usage2 != null) &&
                          (singleObj.energy_provider === 'Gexa Energy' ||
                          singleObj.energy_provider ===
                              'Frontier Utilities')
                        "
                        class="WordSpace mb-0"
                      >
                      <span style="font-weight: bold">Usage Credit</span>:  {{singleObj.usage1Charge}} per billing cycle for usage >={{singleObj.usage1}} kWh
                      </p>
                          <p
                          class="mb-0"
                              
                          *ngIf="
                            (
                            singleObj.energy_provider === 'New Power Texas') && singleObj.billCredit != undefined &&  singleObj.minEnergyUsage !== 0 &&  singleObj.billCredit !== 0
                          "
                        >
                          <span style="font-weight: bold">Usage Credit</span>:
      
                          {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.minEnergyUsage }} kWh
                        </p>

                        
                        <p
                        class="WordSpace mb-0"
                        *ngIf="
                          (
                          singleObj.energy_provider === 'Chariot Energy') && singleObj.billCredit !== '0' &&  singleObj.billCreditTrigger !== '0'
                        "
                      >
                      <span style="font-weight: bold"> Usage Credit:</span>
                      {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.billCreditTrigger }} kWh
                      </p>

                          <div
                          *ngIf="
                            singleObj.energy_provider != 'Pulse Power' &&  singleObj.energy_provider != 'New Power Texas'
                          ">

                          
                          <p class=" mb-0">
                            <span style="font-weight: bold"
                              >TDU Delivery Charge</span
                            >: ${{ recommendedTduCharge }} per billing cycle
                          </p>
                          <p class=" mb-0">
                            <span style="font-weight: bold"
                              >TDU Delivery Charge</span
                            >: ${{ recommendedTduDeliveryCharge }}
                            per kWh
                          </p>
                          </div>

                          <div
                          *ngIf="
                          (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' ) && singleObj.ProductType == 'TimeOfUse'
                          ">

                          
                          <p class=" mb-0">
                            <span style="font-weight: bold"
                              >TDU Delivery Charge</span
                            >: ${{ recommendedTduCharge }} per billing cycle
                          </p>
                          <p class=" mb-0">
                            <span style="font-weight: bold"
                              >TDU Delivery Charge</span
                            >: ${{ recommendedTduDeliveryCharge }}
                            per kWh
                          </p>
                          </div>

                          <div
                          *ngIf="
                          (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' ) && singleObj.ProductType != 'TimeOfUse'
                          ">

                          
                          <!-- <p>
                            <span style="font-weight: bold"
                              >TDU Delivery Charge</span
                            >: Bundled / Included per billing cycle
                          </p>
                          <p>
                            <span style="font-weight: bold"
                              >TDU Delivery Charge</span
                            >: Bundled / Included
                            per kWh
                          </p> -->

                          <p class=" mb-0">
                            <span style="font-weight: bold"
                              >TDU Delivery Charge</span
                            >: ${{ recommendedTduCharge }} per billing cycle
                          </p>
                          <p class=" mb-0">
                            <span style="font-weight: bold"
                              >TDU Delivery Charge</span
                            >: ${{ recommendedTduDeliveryCharge }}
                            per kWh
                          </p>
                          </div>

                          <p
                          class=" mb-0"
                          *ngIf="
                          (singleObj.energy_provider === 'Chariot Energy' ||
                          singleObj.energy_provider === 'APGE Energy')
                          "
                          >
                            <span style="font-weight: bold"
                              > {{ singleObj.energy_provider === 'Chariot Energy' ? "Ercot Securitization Charge" : "Securitization Charge" }}</span
                            >: ${{singleObj.SecuritizationCharge}} per kWh
                          
                          </p>


                        </div>
                        <div
                        *ngIf="
                        singleObj.energy_provider !== 'Pulse Power' &&  singleObj.energy_provider !== 'New Power Texas'
                        "
                          style="
                            font-size: 16px;
                            font-family: Calibre;
                           
                            
                          "
                        >
                          *Avg. Price per kWh = ({{ productTitle }} Energy Charges {{ recommendProduct.energy_provider === 'APGE Energy' ? "+ Base Charge " :"" }}+ TDU
                          Charges {{recommendProduct.energy_provider === 'Chariot Energy' || recommendProduct.energy_provider === 'APGE Energy' ? recommendProduct.SecuritizationChargeLabel : ""}} ) / Total Monthly Usage
                        </div>
                        <div
                        *ngIf="
                        (singleObj.energy_provider === 'Pulse Power' || singleObj.energy_provider === 'New Power Texas' ) && singleObj.ProductType != 'TimeOfUse'
                        "
                          style="
                            font-size: 16px;
                            font-family: Calibre;
                           
                            
                          "
                        >
                        *Avg Price per kWh = (Energy Charge x Total Monthly Usage) + Base Charge
                        </div>
                        <div
                        *ngIf="
                        (singleObj.energy_provider === 'Pulse Power' || singleObj.energy_provider === 'New Power Texas' ) && singleObj.ProductType == 'TimeOfUse'
                        "
                          style="
                            font-size: 16px;
                            font-family: Calibre;
                            
                           
                          "
                        >
                        *Price per kWh = [TDU Delivery Charges per Month + (Monthly billed kWh Usage x (Energy Rate + TDU Delivery Charges per kWh)) - (Energy Rate x applicable Free Charging kWh Usage)]/Monthly Billed kWh Usage.
                        </div>
                    </div>
                    </div>
                  </div>
                </div>
                <div
                  class="plan mobileview row no-gutters px-2"
                  style="border-top: 0px; margin-top: 8px"
                >
                  <div
                    class="fwgtsix pt-2"
                    style="
                      font-size: 16px;
                      font-weight: bolder;
                      text-decoration: underline;
                    "
                    (click)="showHighcharts()"
                  >
                    {{ toggleHighcharts ? 'Hide Estimated Bill & Usage Chart' : 'See Estimated Bill & Usage Chart' }}
                    <mat-icon
                    style="position: absolute;line-height: inherit;"
                    class="pointer"
                  
                    >{{ toggleHighcharts ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                  </div>
                </div>
                <div
                  class="col-12 p-0 float-left mobileTrigger"
                  style="margin-top: 20px"
                  *ngIf="toggleHighcharts"
                >
                  <highcharts-chart
                    [Highcharts]="Highcharts"
                    [options]="highChartsOptions"
                    [(update)]="updateValue"
                    [runOutsideAngular]="true"
                    style="width: 100%; height: 350px; display: block"
                  ></highcharts-chart>
                </div>
                <div class="text-center m-auto pb-2 p-3">
                  <a
                    class="btn signup font12 sectbtnhvr mt-0 mbsign"
                    style="width: 110px"
                    (click)="orderProduct(singleObj)"
                    >Buy Now</a
                  ><br />
                  <i
                    class="fa fa-angle-up font33 pdfclr mt-3"
                    aria-hidden="true"
                    (click)="showDetail1()"
                  ></i>
                </div>
              </div>
            </div>
          </tr>
        </table>
        <br />
        <div
          class="
            col-sm-10 col-md-8
            p-0
            pb-5
            col-lg-8
            text-left
            m-auto
            font-weight-normal-calibre
            avgdetl
          "
        >
          <span
            >*The estimates provided here and throughout the website have been
            calculated to include all of the recurring charges that you will
            normally see on your bill, excluding government fees and taxes. All
            numbers presented are estimates based on information provided by you
            and each energy company. These estimates should be confirmed using
            the information found in the Electricity Facts Label and Terms of
            Service. Please note, your Average Price per kWh and Average Monthly
            Bill Estimate will vary each month according to your actual usage,
            as illustrated in the bar chart above.</span
          >
        </div>
      </div>
    </div>
  </div>
</main>
